// LLM generated - Model Claude 4 Sonnet
import React from 'react';
import { Skeleton, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.other.spacing._8,
    padding: `${theme.other.spacing._12} ${theme.other.spacing._16}`,
    maxWidth: 'calc(100% - 32px)', // Match ChatBubble maxWidth
  },

  avatarSkeleton: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    flexShrink: 0,
  },

  contentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._4,
  },

  headerSkeleton: {
    height: 16,
    width: '40%',
    maxWidth: 120,
  },

  messageSkeleton: {
    height: 14,
    width: '80%',
  },

  messageSkeletonShort: {
    height: 14,
    width: '60%',
  },
}));

type ChatBubbleSkeletonProps = {
  variant?: 'current' | 'other';
  showMultipleLines?: boolean;
};

function ChatBubbleSkeleton({
  variant = 'other',
  showMultipleLines = false,
}: ChatBubbleSkeletonProps) {
  const { classes } = useStyles();

  return (
    <div
      className={classes.container}
      style={{
        flexDirection: variant === 'current' ? 'row-reverse' : 'row',
      }}
    >
      <Skeleton className={classes.avatarSkeleton} />

      <div className={classes.contentContainer}>
        <Skeleton className={classes.headerSkeleton} />
        <Skeleton className={classes.messageSkeleton} />
        {showMultipleLines && <Skeleton className={classes.messageSkeletonShort} />}
      </div>
    </div>
  );
}

ChatBubbleSkeleton.displayName = 'ChatBubbleSkeleton';

// Pattern type for skeleton generation
export type ChatSkeletonPattern = {
  id: string;
  variant: 'other' | 'current';
  showMultipleLines: boolean;
};

/**
 * Generates a consistent chat skeleton pattern for loading states.
 * Returns a fixed pattern of 5 chat bubbles with varied styles.
 * Use this to ensure consistent skeleton rendering across the app.
 */
export function generateChatSkeletonPattern(): ChatSkeletonPattern[] {
  return [
    { id: 'skeleton-1', variant: 'other', showMultipleLines: false },
    { id: 'skeleton-2', variant: 'current', showMultipleLines: false },
    { id: 'skeleton-3', variant: 'other', showMultipleLines: true },
    { id: 'skeleton-4', variant: 'current', showMultipleLines: false },
    { id: 'skeleton-5', variant: 'other', showMultipleLines: false },
  ];
}

export { ChatBubbleSkeleton };
